/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Bright_Wild_Bee_StepInputs */

const en_bright_wild_bee_step = /** @type {(inputs: Bright_Wild_Bee_StepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contact Details`)
};

const de_bright_wild_bee_step = /** @type {(inputs: Bright_Wild_Bee_StepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontaktdaten und Login`)
};

/**
* | output |
* | --- |
* | "Contact Details" |
*
* @param {Bright_Wild_Bee_StepInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const bright_wild_bee_step = /** @type {((inputs?: Bright_Wild_Bee_StepInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bright_Wild_Bee_StepInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_bright_wild_bee_step(inputs)
	return de_bright_wild_bee_step(inputs)
});